import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";
import { IBooking } from "../../types";

interface BookingResponse {
  data: {
    bookings: IBooking[];
    totalCount: number;
  };
}

export const bookingApi = createApi({
  reducerPath: "bookingApi",
  baseQuery: customBaseQuery,
  tagTypes: ["BookingList"],
  endpoints: (builder) => ({
    getBookingList: builder.query<
      BookingResponse,
      { page: number; search?: string }
    >({
      query: ({ page, search }) => {
        let url = `/event/booking/list?pageNumber=${page}&pageSize=10`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return {
          url,
          method: "GET",
        };
      },
      providesTags: [{ type: "BookingList" }],
    }),
    cancelBooking: builder.mutation<void, { bookingId: number }>({
      query: (body) => ({
        url: "/event/booking/cancel",
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")?.toString() || "",
        },
      }),
      invalidatesTags: [{ type: "BookingList" }],
    }),
    // Add more endpoints as needed
  }),
});

export const { useGetBookingListQuery, useCancelBookingMutation } = bookingApi;
